import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from '../../../../../../../chronusStore/helper';
import ChrLink from '../../../../../../generic/Utils/ChrLink';

const RsvpStat = ({url, label, count, btnStatus, eventId, initialStatus, alwaysShowStat}) => {
  const [rsvpCount, setRsvpCount] = useState(count);
  const currentRsvpStatus = useSelector(state => state.eventsListing.eventIdRsvpStatusMap[eventId]);
  const prevRsvpStatus = useRef(initialStatus);

  useEffect(() => {
    if(currentRsvpStatus === btnStatus && prevRsvpStatus.current !== btnStatus)
      setRsvpCount(prevCount => prevCount + 1);
    else if(
      currentRsvpStatus !== undefined &&
      currentRsvpStatus !== btnStatus &&
      prevRsvpStatus.current === btnStatus
    )
      setRsvpCount(prevCount => prevCount - 1)

    if(currentRsvpStatus !== undefined)
      prevRsvpStatus.current = currentRsvpStatus;
  }, [currentRsvpStatus]);

  return(
    <>
      {
        (rsvpCount > 0 || alwaysShowStat) && <div className='mb-2'>
          <ChrLink href={ url }>
            { `${label} (${rsvpCount})` }
          </ChrLink>
        </div>
      }
    </>
  );
};

export default RsvpStat;